import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';

export class OnboardingRepository
{
    activate()
    {
        backdrop.show('Activating your Account...');
        let form = $('#onboarding-form');
        let data = {serial: form.serialize()}

        let success = function(response){
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title
            });
            if(response.type === 'success'){
                backdrop.show('Please wait...')
                window.location.href = '/dashboard'
            }
        }
        let errorMessage = 'Failed activating your account. Please try again later';

        new ApiCalls(data, 'activate', success, errorMessage).dispatch()
    }
}
